import { render, staticRenderFns } from "./ScriptEdit.vue?vue&type=template&id=da28436e&scoped=true"
import script from "./ScriptEdit.vue?vue&type=script&lang=js"
export * from "./ScriptEdit.vue?vue&type=script&lang=js"
import style0 from "./ScriptEdit.vue?vue&type=style&index=0&id=da28436e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da28436e",
  null
  
)

export default component.exports